import { generic_get_network_request } from '../axiosClient/axiosClient';

export interface Library_Info_Type {
  library_id: number;
  library_name: string;
  library_alias: string;
}

export interface LibraryCompany_Type {
  company_id: number;
  library_info: Library_Info_Type[];
}

export interface GetLibrariesByCompany_API_Response_Type {
  data: LibraryCompany_Type[];
}

export const getLibrariesByCompany = (api_endpoint: string) => {
  return generic_get_network_request<GetLibrariesByCompany_API_Response_Type>(api_endpoint);
};


export interface Department_Type {
  department_id: number;
  department_name: string;
}

export interface GetDepartmentsByLibrary_API_Response_Type {
  data: Department_Type[];
}

export interface File_Type {
  file_id: number;
  file_name: string;
}

export interface GetFilesByDepartment_API_Response_Type {
  data: File_Type[];
}

export const getDepartmentsByLibrary = (api_endpoint: string) =>
  generic_get_network_request<GetDepartmentsByLibrary_API_Response_Type>(api_endpoint);

export const getFilesByDepartment = (api_endpoint: string) =>
  generic_get_network_request<GetFilesByDepartment_API_Response_Type>(api_endpoint);
